import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [profile, setProfile] = useState(undefined);

  const loadProfile = useCallback(async () => {
    try {
      const { data } = await api.get("/my-profile");
      setProfile(data || null);
      return data || null;
    } catch {
      setProfile(null);
      return null;
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadProfile();
    } catch {
      setUser(false);
      setProfile(null);
    }
  }, [loadProfile]);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    await loadProfile();
    return data;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setUser(data);
    setProfile(null);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
    setProfile(null);
  };

  return (
    <AuthCtx.Provider value={{ user, profile, setProfile, loadProfile, login, register, logout, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
